import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  AppBar,
  Toolbar,
  Grid,
  Tabs,
  Tab,
  TextField,
  Paper,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  InputAdornment,
  Chip,
  Divider,
  Card,
  CardContent,
  useMediaQuery,
  Dialog,
  DialogContent,
  IconButton as MuiIconButton,
  Fade,
} from "@mui/material";
import {
  RocketLaunch as RocketLaunchIcon,
  Receipt as ReceiptIcon,
  Search as SearchIcon,
  QrCodeScanner as QrCodeScannerIcon,
  Add as AddIcon,
  Remove as RemoveIcon,
  Delete as DeleteIcon,
  Calculate as CalculateIcon,
  Check as CheckIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Fax as FaxIcon,
  WhatsApp as WhatsAppIcon,
  Build as BuildIcon,
  Science as ScienceIcon,
  History as HistoryIcon,
  EmojiEvents as EmojiEventsIcon,
  LocalShipping as LocalShippingIcon,
  Engineering as EngineeringIcon,
  PrecisionManufacturing as PrecisionManufacturingIcon,
  Timeline as TimelineIcon,
  Close as CloseIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  Image as ImageIcon,
  FiberManualRecord as FiberManualRecordIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from "@mui/icons-material";
import "./Home.css";
import LoginPanel from "../../LoginPanel/LoginPanel";
import PDFViewer from "../../scenes/jasperReports/PDFViewer";
import PDFViewerInvoice from "../../scenes/jasperReports/PDFViewerInvoice";
import axios from "axios";
import { DATA_SAVE_URL } from "../../scenes/utils/UrlHandle";
import PDFViewerDialog from "../../scenes/jasperReports/PDFViewerDialog";
import { useLocation } from "react-router-dom";

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

// Image Slider Component
const ImageSlider = ({ scrollToSlider }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const sliderRef = useRef(null);
  const maxSteps = 9;

  // Slider images with your actual image URLs
  const sliderImages = [
    {
      id: 1,
      url: "/assets/slide/Slide1.jpeg",
      title: "Advanced Testing Equipment",
      description: "State-of-the-art testing machinery for accurate results",
    },
    {
      id: 2,
      url: "/assets/slide/Slide2.jpeg",
      title: "Material Testing in Progress",
      description: "Concrete strength testing with precision instruments",
    },
    {
      id: 3,
      url: "/assets/slide/Slide3.jpeg",
      title: "Modern Laboratory Facility",
      description: "Well-equipped testing environment with advanced technology",
    },
    {
      id: 4,
      url: "/assets/slide/Slide4.jpeg",
      title: "Expert Team at Work",
      description: "Dedicated professionals ensuring quality and precision",
    },
    {
      id: 5,
      url: "/assets/slide/Slide5.jpeg",
      title: "Quality Control Process",
      description: "Ensuring accuracy and precision in every test",
    },
    {
      id: 6,
      url: "/assets/slide/Slide6.jpeg",
      title: "Detailed Testing Results",
      description: "Comprehensive analysis and detailed reports",
    },
    {
      id: 7,
      url: "/assets/slide/Slide7.jpeg",
      title: "Detailed Testing Results",
      description: "Comprehensive analysis and detailed reports",
    },
    {
      id: 8,
      url: "/assets/slide/Slide8.png",
      title: "Detailed Testing Results",
      description: "Comprehensive analysis and detailed reports",
    },
    {
      id: 9,
      url: "/assets/slide/Slide9.png",
      title: "Detailed Testing Results",
      description: "Comprehensive analysis and detailed reports",
    },
  ];

  // Preload images for better performance
  useEffect(() => {
    sliderImages.forEach((image) => {
      const img = new Image();
      img.src = image.url;
      img.onload = () => {
        setLoadedImages((prev) => ({ ...prev, [image.id]: true }));
      };
    });
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
    }, 4000);

    return () => clearInterval(timer);
  }, [maxSteps]);

  // Scroll to slider when prop changes
  useEffect(() => {
    if (scrollToSlider && sliderRef.current) {
      sliderRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [scrollToSlider]);

  const handleNext = () => {
    setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => (prevStep - 1 + maxSteps) % maxSteps);
  };

  const handleOpenLightbox = (index) => {
    setCurrentImageIndex(index);
    setOpenLightbox(true);
    // Prevent body scroll when lightbox is open
    document.body.style.overflow = "hidden";
  };

  const handleCloseLightbox = () => {
    setOpenLightbox(false);
    document.body.style.overflow = "unset";
  };

  const handleLightboxNext = () => {
    setCurrentImageIndex((prev) =>
      prev === sliderImages.length - 1 ? 0 : prev + 1,
    );
  };

  const handleLightboxBack = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? sliderImages.length - 1 : prev - 1,
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowLeft") handleLightboxBack();
    if (e.key === "ArrowRight") handleLightboxNext();
    if (e.key === "Escape") handleCloseLightbox();
  };

  return (
    <Box ref={sliderRef}>
      <Paper
        elevation={0}
        sx={{
          mb: 4,
          borderRadius: 3,
          overflow: "hidden",
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(37, 99, 235, 0.1)",
          position: "relative",
          scrollMarginTop: "80px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", p: 2, gap: 1 }}>
          <ImageIcon sx={{ color: "primary.main" }} />
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
            }}
          >
            Our Laboratory Facilities
          </Typography>
        </Box>

        <Box sx={{ position: "relative", width: "100%" }}>
          {/* Main Image Display */}
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: 250, sm: 350, md: 450 },
              overflow: "hidden",
              cursor: "pointer",
            }}
            onClick={() => handleOpenLightbox(activeStep)}
          >
            {!loadedImages[sliderImages[activeStep].id] && (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1,
                }}
              >
                <CircularProgress />
              </Box>
            )}
            <Box
              component="img"
              src={sliderImages[activeStep].url}
              alt={sliderImages[activeStep].title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transition: "transform 0.3s ease",
                opacity: loadedImages[sliderImages[activeStep].id] ? 1 : 0,
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
              onError={(e) => {
                // Fallback if image fails to load
                e.target.src =
                  "https://via.placeholder.com/1200x500/2563eb/ffffff?text=Image+Not+Found";
              }}
            />

            {/* Gradient Overlay */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "50%",
                background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                p: 3,
                color: "white",
                zIndex: 2,
                pointerEvents: "none",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                  fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2rem" },
                }}
              >
                {sliderImages[activeStep].title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                  fontSize: { xs: "0.8rem", sm: "1rem" },
                }}
              >
                {sliderImages[activeStep].description}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  mt: 1,
                  opacity: 0.8,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <FiberManualRecordIcon sx={{ fontSize: 8 }} />
                Click to view full size
              </Typography>
            </Box>
          </Box>

          {/* Navigation Buttons */}
          <MuiIconButton
            onClick={(e) => {
              e.stopPropagation();
              handleBack();
            }}
            sx={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              bgcolor: "rgba(0,0,0,0.4)",
              zIndex: 2,
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <NavigateBeforeIcon sx={{ fontSize: 30 }} />
          </MuiIconButton>

          <MuiIconButton
            onClick={(e) => {
              e.stopPropagation();
              handleNext();
            }}
            sx={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              bgcolor: "rgba(0,0,0,0.4)",
              zIndex: 2,
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <NavigateNextIcon sx={{ fontSize: 30 }} />
          </MuiIconButton>

          {/* Dot Indicators */}
          <Box
            sx={{
              position: "absolute",
              bottom: 100,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: 1,
              zIndex: 2,
            }}
          >
            {sliderImages.map((_, index) => (
              <Box
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveStep(index);
                }}
                sx={{
                  width: activeStep === index ? 12 : 8,
                  height: activeStep === index ? 12 : 8,
                  borderRadius: "50%",
                  bgcolor:
                    activeStep === index ? "white" : "rgba(255,255,255,0.5)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  border:
                    activeStep === index
                      ? "2px solid rgba(255,255,255,0.8)"
                      : "none",
                  "&:hover": {
                    transform: "scale(1.2)",
                    bgcolor:
                      activeStep === index ? "white" : "rgba(255,255,255,0.8)",
                  },
                }}
              />
            ))}
          </Box>

          {/* Slide Counter */}
          <Box
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              bgcolor: "rgba(0,0,0,0.6)",
              color: "white",
              px: 2,
              py: 0.5,
              borderRadius: 2,
              fontSize: "0.875rem",
              zIndex: 2,
              backdropFilter: "blur(5px)",
            }}
          >
            {activeStep + 1} / {maxSteps}
          </Box>
        </Box>

        {/* Thumbnail Preview */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            gap: 1,
            overflowX: "auto",
            bgcolor: "rgba(0,0,0,0.02)",
            "&::-webkit-scrollbar": {
              height: 4,
            },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "primary.main",
              borderRadius: 2,
            },
          }}
        >
          {sliderImages.map((image, index) => (
            <Box
              key={image.id}
              onClick={() => setActiveStep(index)}
              sx={{
                flexShrink: 0,
                width: { xs: 80, sm: 120 },
                height: { xs: 60, sm: 80 },
                borderRadius: 1,
                overflow: "hidden",
                cursor: "pointer",
                border:
                  activeStep === index
                    ? "3px solid #2563eb"
                    : "2px solid transparent",
                opacity: activeStep === index ? 1 : 0.6,
                transition: "all 0.3s ease",
                "&:hover": {
                  opacity: 1,
                  transform: "scale(1.05)",
                },
              }}
            >
              <Box
                component="img"
                src={image.url}
                alt={image.title}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/120x80/cccccc/ffffff?text=Error";
                }}
              />
            </Box>
          ))}
        </Box>
      </Paper>

      {/* Lightbox Dialog - Fixed for Full Screen */}
      <Dialog
        open={openLightbox}
        onClose={handleCloseLightbox}
        maxWidth={false}
        fullWidth={false}
        PaperProps={{
          sx: {
            bgcolor: "rgba(0,0,0,0.95)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100vw",
            height: "100vh",
            maxWidth: "100vw",
            maxHeight: "100vh",
            borderRadius: 0,
            margin: 0,
            zIndex: 9999,
          },
        }}
        onKeyDown={handleKeyDown}
        disableScrollLock={false}
        BackdropProps={{
          sx: {
            backgroundColor: "transparent",
          },
        }}
      >
        <DialogContent
          sx={{
            p: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            bgcolor: "rgba(0,0,0,0.95)",
          }}
        >
          {/* Close Button */}
          <MuiIconButton
            onClick={handleCloseLightbox}
            sx={{
              position: "fixed",
              top: 20,
              right: 20,
              color: "white",
              bgcolor: "rgba(0,0,0,0.5)",
              zIndex: 10000,
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.8)",
              },
            }}
          >
            <CloseIcon sx={{ fontSize: 30 }} />
          </MuiIconButton>

          {/* Navigation Buttons */}
          <MuiIconButton
            onClick={handleLightboxBack}
            sx={{
              position: "fixed",
              left: 20,
              color: "white",
              bgcolor: "rgba(0,0,0,0.5)",
              zIndex: 10000,
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.8)",
              },
            }}
          >
            <NavigateBeforeIcon sx={{ fontSize: 40 }} />
          </MuiIconButton>

          <MuiIconButton
            onClick={handleLightboxNext}
            sx={{
              position: "fixed",
              right: 20,
              color: "white",
              bgcolor: "rgba(0,0,0,0.5)",
              zIndex: 10000,
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.8)",
              },
            }}
          >
            <NavigateNextIcon sx={{ fontSize: 40 }} />
          </MuiIconButton>

          {/* Image Display */}
          <Fade in={openLightbox} timeout={300}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 2, sm: 4 },
                position: "relative",
              }}
            >
              <Box
                component="img"
                src={sliderImages[currentImageIndex]?.url}
                alt={sliderImages[currentImageIndex]?.title}
                sx={{
                  maxWidth: "100%",
                  maxHeight: "85vh",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: 2,
                  boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
                }}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/800x600/2563eb/ffffff?text=Image+Not+Found";
                }}
              />

              {/* Image Info in Lightbox */}
              <Box
                sx={{
                  mt: 3,
                  textAlign: "center",
                  color: "white",
                  position: "absolute",
                  bottom: 20,
                  left: 0,
                  right: 0,
                  px: 2,
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                  {sliderImages[currentImageIndex]?.title}
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.8 }}>
                  {sliderImages[currentImageIndex]?.description}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.6, mt: 1, display: "block" }}
                >
                  {currentImageIndex + 1} of {sliderImages.length}
                </Typography>
              </Box>
            </Box>
          </Fade>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

// Scroll to Slider Button Component
const ScrollToSliderButton = ({ onClick }) => {
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide button when scrolled past 800px
      const scrolled = window.scrollY;
      setShowButton(scrolled < 800);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!showButton) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: { xs: 80, sm: 30 },
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        animation: "bounce 2s infinite",
        "@keyframes bounce": {
          "0%, 20%, 50%, 80%, 100%": {
            transform: "translateX(-50%) translateY(0)",
          },
          "40%": {
            transform: "translateX(-50%) translateY(-20px)",
          },
          "60%": {
            transform: "translateX(-50%) translateY(-10px)",
          },
        },
      }}
    >
      <Button
        variant="contained"
        onClick={onClick}
        startIcon={<KeyboardArrowDownIcon />}
        sx={{
          borderRadius: 50,
          px: { xs: 2, sm: 4 },
          py: { xs: 1, sm: 1.5 },
          background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
          boxShadow: "0 8px 25px rgba(37, 99, 235, 0.4)",
          "&:hover": {
            boxShadow: "0 12px 35px rgba(37, 99, 235, 0.6)",
            transform: "translateY(-2px)",
          },
          fontSize: { xs: "0.8rem", sm: "1rem" },
          fontWeight: 600,
          textTransform: "none",
        }}
      >
        View Our Facilities
      </Button>
    </Box>
  );
};

const Home = ({ onLogin }) => {
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);
  const [labRequestId, setLabRequestId] = useState(null);
  const [reportNo, setReportNo] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [openReportPreviewDialog, setOpenReportPreviewDialog] = useState(false);
  const [scrollToSlider, setScrollToSlider] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  // Report search states
  const [barcode, setBarcode] = useState("");
  const [jobBarcode, setJobBarcode] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const [reportId, setReportId] = useState(null);

  // Labour rates data
  const [labourRates, setLabourRates] = useState([]);

  // New states for search and quotation
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTests, setSelectedTests] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [showQuotation, setShowQuotation] = useState(false);

  const [openProgressModal, setOpenProgressModal] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlLabRequestId = params.get("labRequestId");
    const urlReportNo = params.get("reportNo");

    if (urlLabRequestId && urlReportNo) {
      setLabRequestId(urlLabRequestId);
      setReportNo(urlReportNo);
    }
  }, [location.search]);

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData();
  }, []);

  const handleProgressCloseModal = () => {
    setOpenProgressModal(false);
    // view invoice();
  };

  const loadBasicData = async () => {
    try {
      const response = await axios.get(
        DATA_SAVE_URL + "/api/v1/reports/labRequestRates",
        { withCredentials: true },
      );
      setLabourRates(response.data.allTests);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSearchReport = async () => {
    if (!barcode.trim()) {
      setSearchError("Please enter a barcode");
      return;
    }

    try {
      handleOpenReportPreview();
      setSearchLoading(true);
      setSearchError(null);
      setSearchResult(null);
    } catch (error) {
      setSearchError("Error searching for report");
      console.error("Search error:", error);
    } finally {
      setSearchLoading(false);
    }
  };

  //handle get progress
  const handleGetProgress = async () => {
    if (!jobBarcode.trim()) {
      alert("Please enter a barcode number");
      return;
    }
    // setLoading(true);
    try {
      const response = await axios.get(
        DATA_SAVE_URL + "/api/v1/reports/progressJob/" + 1,
        {
          responseType: "json",
          params: {
            barcode: jobBarcode,
          },
        },
      );

      console.log(response.data);
      setSelectedRequestId(response.data);
      setOpenProgressModal(true);
    } catch (error) {
      console.error("Error fetching PDF:", error);
      // setError("Failed to load PDF. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  // New functions for test selection and quotation
  const handleAddTest = (test) => {
    if (!selectedTests.find((t) => t.id === test.id)) {
      setSelectedTests([...selectedTests, test]);
      setQuantities({
        ...quantities,
        [test.id]: 1,
      });
    }
  };

  const handleOpenReportPreview = () => {
    setOpenReportPreviewDialog(true);
  };

  const handleCloseReportPreview = () => {
    setOpenReportPreviewDialog(false);
  };

  const handleRemoveTest = (testId) => {
    setSelectedTests(selectedTests.filter((t) => t.id !== testId));
    const newQuantities = { ...quantities };
    delete newQuantities[testId];
    setQuantities(newQuantities);
  };

  const handleQuantityChange = (testId, change) => {
    setQuantities({
      ...quantities,
      [testId]: Math.max(1, (quantities[testId] || 1) + change),
    });
  };

  const handleScrollToSlider = () => {
    setScrollToSlider(true);
    // Reset the scroll trigger after animation
    setTimeout(() => {
      setScrollToSlider(false);
    }, 1000);
  };

  const calculateTotal = () => {
    return selectedTests.reduce((total, test) => {
      const rate = parseFloat(test.amount) || 0;
      const quantity = quantities[test.id] || 1;
      return total + rate * quantity;
    }, 0);
  };

  const filteredTests = labourRates.filter((test) =>
    test.testName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  // Contact information
  const contactInfo = {
    department: "PROVINCIAL ENGINEERING DEPARTMENT - NORTH CENTRAL PROVINCE",
    email: "support@matlab.lk",
    tel: "025 226 3285",
    fax: "025 226 5490",
    whatsapp: "076 836 3285",
  };

  // Company description
  const companyDescription = `Established in 2000 under the Provincial Engineering Department, North Central Province, 
  the Material Testing Laboratory - Kekirawa has been a cornerstone of quality assurance in the construction industry. 
  Strategically located in Kekirawa City, our state-of-the-art facility has continuously served the local and national 
  construction community, earning a reputation as one of the top-performing institutions in the North Central Province. 
  With a commitment to precision and reliability, we offer over 50 specialized testing services in various disciplines, 
  including concrete, soil, aggregates, bricks, cement, bituminous materials, aluminum, and more. Our advanced technologies 
  and expert team ensure that we deliver comprehensive testing solutions across the island, right to your doorstep. 
  Whether you are a contractor, engineer, or developer, Material Testing Laboratory - Kekirawa is your trusted partner 
  in maintaining construction excellence.`;

  // Company highlights for better visual presentation
  const highlights = [
    { icon: <HistoryIcon />, text: "Established in 2000", color: "#ff9800" },
    {
      icon: <EmojiEventsIcon />,
      text: "Top-Performing Institution",
      color: "#4caf50",
    },
    { icon: <ScienceIcon />, text: "50+ Specialized Tests", color: "#2196f3" },
    {
      icon: <LocalShippingIcon />,
      text: "Island-Wide Service",
      color: "#9c27b0",
    },
    { icon: <EngineeringIcon />, text: "Expert Team", color: "#f44336" },
    {
      icon: <PrecisionManufacturingIcon />,
      text: "Advanced Technology",
      color: "#009688",
    },
  ];

  // If labRequestId is present and we're on report tab, show PDF viewer
  if (labRequestId && reportNo) {
    return (
      <Box className="hero-section">
        <AppBar position="fixed" elevation={0} className="glass-navbar">
          <Toolbar>
            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
              <RocketLaunchIcon sx={{ mr: 2, color: "primary.main" }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  background:
                    "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  fontSize: { xs: "1rem", sm: "1.25rem" },
                }}
              >
                Material Laboratory System - Kekirawa
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>

        <Container maxWidth="xl" sx={{ pt: 10, px: { xs: 1, sm: 2 } }}>
          <Box className="fade-in">
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                mb: 3,
                fontSize: { xs: "1.5rem", sm: "2rem" },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              {reportNo?.startsWith("QC")
                ? "Lab Report No - #" + reportNo
                : "Invoice No - #" + reportNo}
            </Typography>

            {reportNo?.startsWith("QC") ? (
              <PDFViewer
                reportNo={reportNo}
                labRequestId={labRequestId}
                letterHead={true}
              />
            ) : (
              <PDFViewerInvoice
                reportNo={reportNo}
                labRequestId={labRequestId}
                letterHead={true}
                jobId={592}
              />
            )}
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box className="hero-section">
      {/* Navigation */}
      <AppBar position="fixed" elevation={0} className="glass-navbar">
        <Toolbar sx={{ px: { xs: 1, sm: 2 } }}>
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <RocketLaunchIcon
              sx={{
                mr: 2,
                color: "primary.main",
                fontSize: { xs: 20, sm: 24 },
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
                fontSize: { xs: "1rem", sm: "1.25rem" },
              }}
            >
              MatLab
            </Typography>
          </Box>
          <Button
            variant="contained"
            onClick={() => setShowLogin(true)}
            sx={{
              background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
              borderRadius: 3,
              px: { xs: 2, sm: 4 },
              py: 1,
              fontSize: { xs: "0.8rem", sm: "0.9rem" },
            }}
          >
            Sign In
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container maxWidth="xl" sx={{ pt: 12, px: { xs: 2, sm: 3 } }}>
        {!showLogin ? (
          <Box className="fade-in">
            {/* Hero Section with Laboratory Name and Contact Info */}
            <Paper
              elevation={0}
              sx={{
                mb: 4,
                p: { xs: 3, sm: 5 },
                borderRadius: 4,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                textAlign: "center",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: -50,
                  right: -50,
                  width: 200,
                  height: 200,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                  zIndex: 0,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                  zIndex: 0,
                }}
              />

              <Box sx={{ position: "relative", zIndex: 1 }}>
                {/* Title with Flags */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: { xs: 2, sm: 3 },
                    mb: 2,
                    flexWrap: "wrap",
                  }}
                >
                  {/* Left Flag */}
                  <Box
                    component="img"
                    src="/assets/Gove.png"
                    alt="Sri Lanka Flag"
                    sx={{
                      width: { xs: 40, sm: 60, md: 100 },
                      height: "auto",
                      borderRadius: 0.25,
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://flagcdn.com/w320/lk.png";
                    }}
                  />

                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 800,
                      fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3.5rem" },
                      textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                      letterSpacing: 1,
                    }}
                  >
                    Material Testing Laboratory
                  </Typography>

                  {/* Right Flag */}
                  <Box
                    component="img"
                    src="/assets/ncp.png"
                    alt="Provincial Flag"
                    sx={{
                      width: { xs: 40, sm: 60, md: 120 },
                      height: "auto",
                      borderRadius: 0.25,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://flagcdn.com/w320/lk.png";
                    }}
                  />
                </Box>

                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
                    mb: 2,
                    opacity: 0.95,
                  }}
                >
                  Kekirawa
                </Typography>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    fontSize: { xs: "1rem", sm: "1.1rem" },
                    letterSpacing: 1,
                  }}
                >
                  {contactInfo.department}
                </Typography>

                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: 2,
                    justifyContent: "center",
                    maxWidth: 800,
                    mx: "auto",
                  }}
                >
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <EmailIcon sx={{ fontSize: 20 }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                      >
                        {contactInfo.email}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <PhoneIcon sx={{ fontSize: 20 }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                      >
                        {contactInfo.tel}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <FaxIcon sx={{ fontSize: 20 }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                      >
                        {contactInfo.fax}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <WhatsAppIcon sx={{ fontSize: 20 }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
                      >
                        {contactInfo.whatsapp}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                {/* Company Highlights Grid */}
                <Grid
                  container
                  spacing={2}
                  sx={{
                    mb: 4,
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {highlights.map((highlight, index) => (
                    <Grid item xs={6} sm={4} md={2} key={index}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 1,
                          p: 1.5,
                          borderRadius: 2,
                          background: "rgba(255, 255, 255, 0.15)",
                          backdropFilter: "blur(5px)",
                          transition: "transform 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-5px)",
                            background: "rgba(255, 255, 255, 0.25)",
                          },
                        }}
                      >
                        <Box sx={{ color: highlight.color, fontSize: 32 }}>
                          {highlight.icon}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 600,
                            fontSize: { xs: "0.7rem", sm: "0.75rem" },
                            textAlign: "center",
                          }}
                        >
                          {highlight.text}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>

                <Divider
                  sx={{
                    width: 100,
                    mx: "auto",
                    my: 3,
                    borderColor: "rgba(255,255,255,0.3)",
                    borderWidth: 2,
                  }}
                />
              </Box>
            </Paper>

            {/* Company Description Section */}
            <Paper
              elevation={0}
              sx={{
                mb: 4,
                p: { xs: 3, sm: 4 },
                borderRadius: 3,
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(37, 99, 235, 0.1)",
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1 }}
              >
                <BuildIcon sx={{ color: "primary.main" }} />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  About Material Testing Laboratory - Kekirawa
                </Typography>
              </Box>

              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  color: "text.primary",
                  textAlign: "justify",
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                }}
              >
                {companyDescription}
              </Typography>

              {/* Additional Stats or Services */}
              <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      background:
                        "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontWeight: 600, color: "#2563eb" }}
                      >
                        Our Vision
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        To be the premier material testing facility in Sri
                        Lanka, setting benchmarks for quality, accuracy, and
                        reliability in construction testing.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      background:
                        "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontWeight: 600, color: "#2563eb" }}
                      >
                        Our Mission
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        To provide accurate, timely, and reliable material
                        testing services that ensure construction quality and
                        safety across Sri Lanka.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Card
                    sx={{
                      background:
                        "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
                      borderRadius: 2,
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontWeight: 600, color: "#2563eb" }}
                      >
                        Our Commitment
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Delivering excellence through advanced technology,
                        expert knowledge, and unwavering dedication to quality
                        assurance.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Paper>

            {/* Image Slider Section - Added here */}
            <ImageSlider scrollToSlider={scrollToSlider} />

            {/* Scroll to Slider Button - Shows on page load */}
            <ScrollToSliderButton onClick={handleScrollToSlider} />

            {/* Tabs Navigation */}
            <Paper
              elevation={0}
              sx={{
                mb: 3,
                borderRadius: 2,
                background: "rgba(255, 255, 255, 0.8)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  "& .MuiTab-root": {
                    fontSize: { xs: "0.8rem", sm: "1rem" },
                    fontWeight: 600,
                    textTransform: "none",
                  },
                }}
              >
                <Tab
                  icon={<ReceiptIcon sx={{ mr: 1 }} />}
                  label="Laboratory Rates"
                  iconPosition="start"
                />
                <Tab
                  icon={<QrCodeScannerIcon sx={{ mr: 1 }} />}
                  label="View Report"
                  iconPosition="start"
                />
                <Tab
                  icon={<TimelineIcon sx={{ mr: 1 }} />}
                  label="Track Your Job"
                  iconPosition="start"
                />
              </Tabs>
            </Paper>

            {/* Tab 2: Laboratory Rates with Quotation Builder */}
            <TabPanel value={tabValue} index={0}>
              <Grid container spacing={3}>
                {/* Left Column - Test List */}
                <Grid item xs={12} md={7}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: { xs: 2, sm: 3 },
                      background: "rgba(255, 255, 255, 0.9)",
                      backdropFilter: "blur(10px)",
                      borderRadius: 3,
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 3,
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 600,
                          background:
                            "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                          backgroundClip: "text",
                          WebkitBackgroundClip: "text",
                          color: "transparent",
                        }}
                      >
                        Laboratory Testing Rates
                      </Typography>

                      <TextField
                        size="small"
                        placeholder="Search tests..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: "100%", sm: 250 } }}
                      />
                    </Box>

                    <TableContainer sx={{ maxHeight: 600 }}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Test Name
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Rate</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredTests.map((test, index) => {
                            const isSelected = selectedTests.some(
                              (t) => t.id === test.id,
                            );
                            return (
                              <TableRow key={index} hover>
                                <TableCell>{test.testName}</TableCell>
                                <TableCell
                                  sx={{
                                    fontWeight: 600,
                                    color: "primary.main",
                                  }}
                                >
                                  {test.amount.toLocaleString() + ".00"}
                                </TableCell>
                                <TableCell>
                                  {!isSelected ? (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      startIcon={<AddIcon />}
                                      onClick={() => handleAddTest(test)}
                                      sx={{ borderRadius: 2 }}
                                    >
                                      Add
                                    </Button>
                                  ) : (
                                    <Chip
                                      label="Added"
                                      color="success"
                                      size="small"
                                      icon={<CheckIcon />}
                                    />
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          {filteredTests.length === 0 && (
                            <TableRow>
                              <TableCell
                                colSpan={4}
                                align="center"
                                sx={{ py: 4 }}
                              >
                                <Typography color="text.secondary">
                                  No tests found matching your search
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Grid>

                {/* Right Column - Quotation Builder */}
                <Grid item xs={12} md={5}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: { xs: 2, sm: 3 },
                      background: "rgba(255, 255, 255, 0.9)",
                      backdropFilter: "blur(10px)",
                      borderRadius: 3,
                      top: 100,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <CalculateIcon sx={{ mr: 1, color: "primary.main" }} />
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        Quotation Builder
                      </Typography>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    {selectedTests.length === 0 ? (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <ReceiptIcon
                          sx={{ fontSize: 48, color: "text.disabled", mb: 2 }}
                        />
                        <Typography color="text.secondary">
                          No tests selected. Add tests from the list to create a
                          quotation.
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        <Box sx={{ maxHeight: 650, overflow: "auto", mb: 2 }}>
                          {selectedTests.map((test) => {
                            const rate = parseFloat(test.amount) || 0;
                            const quantity = quantities[test.id] || 1;
                            return (
                              <Paper
                                key={test.id}
                                elevation={0}
                                sx={{
                                  p: 2,
                                  mb: 1,
                                  background: "rgba(37, 99, 235, 0.05)",
                                  border: "1px solid rgba(37, 99, 235, 0.1)",
                                  borderRadius: 2,
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    mb: 1,
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 600 }}
                                  >
                                    {test.testName}
                                  </Typography>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleRemoveTest(test.id)}
                                    sx={{ color: "error.main" }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Box>

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Qty:
                                    </Typography>
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleQuantityChange(test.id, -1)
                                      }
                                      disabled={quantities[test.id] <= 1}
                                    >
                                      <RemoveIcon fontSize="small" />
                                    </IconButton>
                                    <Typography
                                      sx={{ minWidth: 30, textAlign: "center" }}
                                    >
                                      {quantity}
                                    </Typography>
                                    <IconButton
                                      size="small"
                                      onClick={() =>
                                        handleQuantityChange(test.id, 1)
                                      }
                                    >
                                      <AddIcon fontSize="small" />
                                    </IconButton>
                                  </Box>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 600,
                                      color: "primary.main",
                                    }}
                                  >
                                    Rs. {(rate * quantity).toLocaleString()}
                                  </Typography>
                                </Box>
                              </Paper>
                            );
                          })}
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Box sx={{ mb: 2 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mt: 1,
                            }}
                          >
                            <Typography variant="h6">Grand Total:</Typography>
                            <Typography
                              variant="h6"
                              sx={{ color: "primary.main", fontWeight: 700 }}
                            >
                              Rs. {calculateTotal().toLocaleString()}
                            </Typography>
                          </Box>
                        </Box>
                      </>
                    )}
                  </Paper>
                </Grid>
              </Grid>
            </TabPanel>

            {/* Tab 2: View Report */}
            <TabPanel value={tabValue} index={1}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, sm: 5 },
                  maxWidth: 800,
                  mx: "auto",
                  textAlign: "center",
                  background: "rgba(255, 255, 255, 0.9)",
                  backdropFilter: "blur(10px)",
                  borderRadius: 4,
                }}
              >
                <QrCodeScannerIcon
                  sx={{ fontSize: 60, color: "primary.main", mb: 2 }}
                />

                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    background:
                      "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  Verify Your Report
                </Typography>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mb: 4 }}
                >
                  Enter the barcode number from your report to view the document
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter barcode number"
                    value={barcode}
                    onChange={(e) => setBarcode(e.target.value)}
                    onKeyPress={(e) =>
                      e.key === "Enter" && handleSearchReport()
                    }
                    error={!!searchError}
                    helperText={searchError}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={handleSearchReport}
                    disabled={searchLoading}
                    startIcon={
                      searchLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <SearchIcon />
                      )
                    }
                    sx={{
                      px: 4,
                      borderRadius: 2,
                      background:
                        "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                      minWidth: { xs: "100%", sm: "auto" },
                    }}
                  >
                    {searchLoading ? "Searching..." : "Generate"}
                  </Button>
                </Box>
              </Paper>
            </TabPanel>

            {/* Tab 3: Tracking Report */}
            <TabPanel value={tabValue} index={2}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, sm: 5 },
                  maxWidth: 800,
                  mx: "auto",
                  textAlign: "center",
                  background: "rgba(255, 255, 255, 0.9)",
                  backdropFilter: "blur(10px)",
                  borderRadius: 4,
                }}
              >
                <TimelineIcon
                  sx={{ fontSize: 60, color: "primary.main", mb: 2 }}
                />

                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    background:
                      "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  Job Trackings
                </Typography>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mb: 4 }}
                >
                  Enter the barcode number of your Job
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter barcode number"
                    value={jobBarcode}
                    onChange={(e) => setJobBarcode(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && handleGetProgress}
                    error={!!searchError}
                    helperText={searchError}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={handleGetProgress}
                    disabled={searchLoading}
                    startIcon={
                      searchLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <SearchIcon />
                      )
                    }
                    sx={{
                      px: 4,
                      borderRadius: 2,
                      background:
                        "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)",
                      minWidth: { xs: "100%", sm: "auto" },
                    }}
                  >
                    {searchLoading ? "Searching..." : "Generate"}
                  </Button>
                </Box>
              </Paper>
            </TabPanel>
          </Box>
        ) : (
          <LoginPanel
            onLogin={(userData) => {
              setShowLogin(false);
              onLogin(userData);
            }}
            onClose={() => setShowLogin(false)}
          />
        )}
      </Container>
      <PDFViewerDialog
        reportNo={"QC-REPORT " + barcode}
        labRequestId={barcode}
        open={openReportPreviewDialog}
        handleCloseReportPreview={handleCloseReportPreview}
        reportType={"REPORT"}
        letterHead={true}
        isVerified={true}
      />
      {
        <PDFViewerDialog
          data={selectedRequestId}
          isNonMobile={isNonMobile}
          handleCloseReportPreview={handleProgressCloseModal}
          open={openProgressModal}
          reportType={"PROGRESS"}
        />
      }
    </Box>
  );
};

export default Home;
